<template>
  <div class="segment-input-group">
    <div class="input-name">{{internalValues.view.name}}</div>
    <div class="segment-container">
      <!-- {{internalValues.value[0]}} -->
      <segment-input-container v-for="(segmentGroup,i) in internalValues.value" :key="i" 
        v-model="internalValues.value[i]"
        @change="onValuesChange"
        :canBeRemoved="canRemoveSegments"
        @remove="onRemoveSegment"
        v-on="$listeners"
      />
      
      <!-- <segment-input-container :readOnly="readOnly" :fieldConfig="fieldConfig" @change="onFieldChange"></segment-input-container> -->

    </div>
    <div class="add-button" v-if="canAddMoreSegments()" @click="onAddSegment">+ Add config block</div>
    <div class="no-more-add" v-else>Max {{maxSegments}} config block</div>
  </div>
</template>

<script>
import SegmentInputContainer from '@/components/inputs/SegmentInputContainer'

export default {
  name: 'SegmentRelatedInputGroup',
  components: {SegmentInputContainer},
  props: ['values'],
  model:{
    prop: 'values',
    event: 'change'
  },
  computed:{
    internalValues: {
      get () {
        return this.values
      },
      set (value) {
        // console.log("By Set")
        // this.$emit('change',value)
      }
    },
    maxSegments() {
      // return this.fieldConfig.segmentConfig.maxCount
      return this.internalValues.view.validate_max ? this.internalValues.view.validate_max : Infinity
    },
    minSegments() {
      return this.internalValues.view.validate_min ? this.internalValues.view.validate_min : 0
    },
    canRemoveSegments(){
      // return this.fieldConfig.value.length > this.minSegments
      return this.internalValues.value.length > (this.internalValues.view.validate_min || 0)
    }
  },
  methods:{
    onValuesChange (){
      // console.log("By Change")
      this.$emit('change',JSON.parse(JSON.stringify(this.internalValues)))
    },
    onAddSegment(){
      // let newSegment = {segmentId: null}
      // if(this.fieldConfig.subFieldList){
      //   newSegment.subFieldList = JSON.parse(JSON.stringify(this.fieldConfig.subFieldList))
      //   newSegment.subFieldList.forEach((sf)=>{
      //     let key = getValueTypeKey(sf)
      //     sf.value = {}
      //     sf.value[key] = null
      //   })
      // } else {
      //   newSegment.parameterConfig = JSON.parse(JSON.stringify(this.fieldConfig.parameterConfig))
      //   let key = getValueTypeKey(newSegment)
      //   newSegment.value = {}
      //   newSegment.value[key] = null

      // }
      // this.fieldConfig.value.push(newSegment)
      // this.enterPickerMode(this.fieldConfig.segmentList.length-1)
      let newSegment = JSON.parse(JSON.stringify(this.internalValues.value[0]))
      newSegment.value[0].value = []
      this.internalValues.value.push(newSegment)
    },
    onRemoveSegment(s){
      this.internalValues.value = this.internalValues.value.filter((ss)=>ss!==s)
    },
    canAddMoreSegments(){
      // return this.fieldConfig.value.length < this.maxSegments
      return this.internalValues.value.length < (this.internalValues.view.validate_max || Infinity)
    }    
  }
}
</script>

<style lang="stylus" scoped>
.segment-input-group
  margin-bottom: 20px

  .input-name
    m-font-size(16, 18)
    font-weight: $fw-light
    margin-bottom: 10px
    text-transform: uppercase

  .input-component-container
    display: flex
  
  // ho he copiat dun altre puesto
  .add-button
    background: rgba(255, 255, 255, 0.5)
    border: 1px solid $cloud-burst
    border-radius: 20px
    // width 100px
    color: $cloud-burst
    cursor: pointer
    margin: 20px 0
    max-width: 150px
    padding: 7px
    text-align: center

    &:hover
      background: rgba(255, 255, 255, 0.9)

  .no-more-add
    color $storm-gray
    opacity 0.5
</style>